import React, { useState, useEffect, Component } from "react";
import SideNav from "./sidenav";
import Downloads from "../images/downloadicon.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import "./nav.css";
import { ApolloClient, HttpLink, InMemoryCache, gql } from "@apollo/client";
import { ApolloProvider } from "@apollo/client/react";
import Footer from "./footer";
import AOS from 'aos';


const client = new ApolloClient({
  link: new HttpLink({ uri: "https://pensure-cms.inspireleadership.biz/graphql"}),
  cache: new InMemoryCache(),
});


const Download = () => {

   window.scrollTo(0, 0)

   
  const [active, setActive] = useState("FINANCIAL REPORTS");
  const [reports, setReports] = useState([]);
  const [forms, setForms] = useState([]);
  const [regulations, setRegulations] = useState([]);
   const [others, setOthers] = useState([]);

  const menuItems = ["FINANCIAL REPORTS", "FORMS", "REGULATIONS", "OTHERS"];



useEffect( () => {
                       AOS.init({
                        offset: 0,
                        duration: 1000,
                        once: true
                      });
                    
                        
                    }, [])

useEffect( () => {

        

      
  client
        .query({
          query: gql`
  query NewQuery {
    pages(first:100) {
     edges {
      node {
        downloadables {
          financeReports {
            description
            link
            name
          }
          forms {
            description
            link
            name
          }
          others {
            description
            link
            name
          }
          regulation {
            description
            link
            name
          }
        }
      }
    }
  }
      }
          `,
        })
        .then((result) => {
      
           console.log(result)

            setReports(result.data.pages.edges[10].node.downloadables.financeReports)
            setForms(result.data.pages.edges[10].node.downloadables.forms)
            setRegulations(result.data.pages.edges[10].node.downloadables.regulation)
            setOthers(result.data.pages.edges[10].node.downloadables.others)

         
        });
      
      }, [])  

  return (

    <>
    <div
      class="d-flex align-items-start  mt-4"
      style={{ backgroundColor: "none" }}
    >
      <SideNav items={menuItems} activeItem={active} onSelect={setActive} types={false} />

      <div className="full-width p-6">
        {active === "FINANCIAL REPORTS" && (
     

             reports.map((yearlyreports, idx) => (


                      idx === 0 ?
                   <div className=" containeer crd-div row-gap-5">
          
                 <h2 className="payment-h2"  data-aos="fade-up" data-aos-delay="200">Financial Reports</h2>
              <p id="crd-p" className="grey-p"  data-aos="fade-up" data-aos-delay="200">
                {" "}
                Review our track record of transparency and performance.
              </p>

                <hr className="btm-bdr-rma mb-4" />
        
           <div key={idx} id="fnc-card" className=" "  data-aos="fade-up" data-aos-delay="200">
                  <div>
                    {" "}
                    <h5 className="finance-h5">
                     {yearlyreports.name} Financial Report
                    </h5>
                    <p className="finance-p">
                      {" "}
                     Full year  {yearlyreports.name} financial summary including income, expenses, investments and more
                    </p>
                  </div>
                  <a className="no-decoration dwn-btn-fnc d-flex align-items-center" href={yearlyreports.link}>
                    {" "}
                    Download {yearlyreports.name} Report{" "}
                    <img className="ms-2" src={Downloads} alt="Download" />
                  </a>
                </div>
                </div>

                :

            <div className=" containeer crd-div row-gap-5">
        
                <hr className="btm-bdr-rma mb-4" />
        
           <div key={idx} id="fnc-card" className=" " data-aos="fade-up" data-aos-delay="200">
                  <div>
                    {" "}
                    <h5 className="finance-h5">
                     {yearlyreports.name} Financial Report
                    </h5>
                    <p className="finance-p">
                      {" "}
                     Full year  {yearlyreports.name} financial summary including income, expenses, investments and more
                    </p>
                  </div>
                  <a className="no-decoration dwn-btn-fnc d-flex align-items-center" href={yearlyreports.link}>
                    {" "}
                    Download {yearlyreports.name} Report{" "}
                    <img className="ms-2" src={Downloads} alt="Download" />
                  </a>
                </div>
                </div>
   

          ))
        )}
        {active === "FORMS" && (
                   forms.map((forms, idx) => (

                      idx === 0 ?
                   <div className=" containeer crd-div row-gap-5" >
          
                 <h2 className="payment-h2" data-aos="fade-up" data-aos-delay="200">Forms</h2>
              <p id="crd-p" className="grey-p" data-aos="fade-up" data-aos-delay="200">
                {" "}
                Download essential forms for your retirement, contributions, or claims.
              </p>

                <hr className="btm-bdr-rma mb-4" />
        
           <div key={idx} id="fnc-card" className=" " data-aos="fade-up" data-aos-delay="200">
                  <div>
                   
                    <h5 className="finance-h5">
                     {forms.name} 
                    </h5>
                    <p className="finance-p">
                   
                     {forms.description}
                    </p>
                  </div>
                  <a className="no-decoration dwn-btn-fnc d-flex align-items-center" href={forms.link}>
                    {" "}
                    Download form{" "}
                    <img className="ms-2" src={Downloads} alt="Download" />
                  </a>
                </div>
                </div>

                :

            <div className=" containeer crd-div row-gap-5">
        
                <hr className="btm-bdr-rma mb-4" />
        
           <div key={idx} id="fnc-card" className=" " data-aos="fade-up" data-aos-delay="200">
                  <div>
                    {" "}
                    <h5 className="finance-h5">
                     {forms.name}
                    </h5>
                    <p className="finance-p">
                      {" "}
                    {forms.description} 
                    </p>
                  </div>
                  <a className="no-decoration dwn-btn-fnc d-flex align-items-center" href={forms.link}>
                    {" "}
                    Download form{" "}
                    <img className="ms-2" src={Downloads} alt="Download" />
                  </a>
                </div>
                </div>
   

          ))
        )}
        {active === "REGULATIONS" && (
           regulations.map((regulate, idx) => (

                   idx === 0 ?
                   <div className=" containeer crd-div row-gap-5">
          
                 <h2 className="payment-h2" data-aos="fade-up" data-aos-delay="200">Regulations</h2>
              <p id="crd-p" className="grey-p" data-aos="fade-up" data-aos-delay="200">
                {" "}
                Stay informed with the latest regulatory guidelines and compliance frameworks.
              </p>

                <hr className="btm-bdr-rma mb-4" />
        
           <div key={idx} id="fnc-card" className=" " data-aos="fade-up" data-aos-delay="200">
                  <div>
                    {" "}
                    <h5 className="finance-h5">
                     {regulate.name} 
                    </h5>
                    <p className="finance-p">
                      {" "}
                    {regulate.description}
                    </p>
                  </div>
                  <a className="no-decoration dwn-btn-fnc d-flex align-items-center" href={regulate.link}>
                    {" "}
                    Download form{" "}
                    <img className="ms-2" src={Downloads} alt="Download" />
                  </a>
                </div>
                </div>

                :

            <div className=" containeer crd-div row-gap-5" >
        
                <hr className="btm-bdr-rma mb-4" />
        
           <div key={idx} id="fnc-card" className=" " data-aos="fade-up" data-aos-delay="200">
                  <div>
                    {" "}
                    <h5 className="finance-h5">
                    {regulate.name}
                    </h5>
                    <p className="finance-p">
                      {" "}
                    {regulate.description}
                    </p>
                  </div>
                  <a className="no-decoration dwn-btn-fnc d-flex align-items-center" href={regulate.link}>
                    {" "}
                    Download form {" "}
                    <img className="ms-2" src={Downloads} alt="Download" />
                  </a>
                </div>
                </div>
   

          ))
        )}
        {active === "OTHERS" && (
           others.map((other, idx) => (

              idx === 0 ?
         <div className=" containeer crd-div row-gap-5">
          
                 <h2 className="payment-h2" data-aos="fade-up" data-aos-delay="200">Others</h2>
              <p id="crd-p" className="grey-p" data-aos="fade-up" data-aos-delay="200">
                {" "}
                Other documents and resources to support your pension journey
              </p>

                <hr className="btm-bdr-rma mb-4" />
        
           <div key={idx} id="fnc-card" className=" " data-aos="fade-up" data-aos-delay="200">
                  <div>
                    {" "}
                    <h5 className="finance-h5">
                     {others.name} 
                    </h5>
                    <p className="finance-p">
                      {" "}
                    {others.description}
                    </p>
                  </div>
                  <a className="no-decoration dwn-btn-fnc d-flex align-items-center" href={other.link}>
                    {" "}
                    Download form{" "}
                    <img className="ms-2" src={Downloads} alt="Download" />
                  </a>
                </div>
                </div>

                :

            <div className=" containeer crd-div row-gap-5">
        
                <hr className="btm-bdr-rma mb-4" />
        
           <div key={idx} id="fnc-card" className=" " data-aos="fade-up" data-aos-delay="200">
                  <div>
                    {" "}
                    <h5 className="finance-h5">
                    {others.name}
                    </h5>
                    <p className="finance-p">
                      {" "}
                    {others.description}
                    </p>
                  </div>
                  <a className="no-decoration dwn-btn-fnc d-flex align-items-center" href={others.link}>
                    {" "}
                    Download form {" "}
                    <img className="ms-2" src={Downloads} alt="Download" />
                  </a>
                </div>
                </div>
          ))
        )}
      </div>
    </div>
 <Footer/>
           <div className='height'> 

              </div>
    </>
  );
};

export default Download;
